import React, {useContext} from 'react';
import { MDBContainer, MDBRow, MDBCard, MDBCardBody, MDBCol } from "mdb-react-ui-kit";
import { ThemeContext } from '../../../Context/ThemeContext';

const CardLayout = ({ children, title, logo='', customerLogo=false }) => {
    const { appliedTheme } = useContext(ThemeContext);
    
    // Determine which logo to use (match applied shell: light on auth pages)
    const useCustomerLogo = customerLogo === true && logo && logo.trim() !== '';
    const logoSrc = useCustomerLogo 
        ? logo 
        : (appliedTheme === "dark" || appliedTheme === "high-contrast" 
            ? process.env.REACT_APP_WEB_URL + "pbs-logo-dark.svg" 
            : process.env.REACT_APP_WEB_URL + "pbs-logo.svg");
    
    return (
    <MDBContainer className="pt-2 mt-5">
        <MDBRow className="mt-3 d-flex justify-content-center mb-4">
            <div className="card-body text-center auth-logo mb-2">
                <img className="mb-3" src={logoSrc} alt="logo" style={{ height: '85%', width: '95%', maxWidth: '425px' }} />
            </div>
            <h5 className="card-body text-center auth-logo mb-2">{title}</h5>
            <MDBCol md="6" className="mb-4 mb-md-0 fixed-height mb-4 mt-4">
                <MDBCard className="h-100 auth-card-layout add-user-flow-modal">
                    <MDBCardBody className="p-4">
                        {children}
                    </MDBCardBody>
                </MDBCard>
            </MDBCol>
        </MDBRow>
    </MDBContainer>
    );
};

export default CardLayout;
